<template>
  <div class="identity-overage display">
    <div class="md-layout md-gutter">
      <div class="md-layout-item md-small-size-100">
        <p class="title md-headline">Identity verification overages</p>
      </div>
    </div>

    <div v-if="!localEnterprise.billingCustomer.id">
      <div class="md-layout md-gutter mb-1">
        <div class="md-layout-item md-small-size-100">
          <p class="md-subheading">
            Please configure Stripe Customer ID to edit identity overage information.
          </p>
        </div>
      </div>
    </div>

    <div v-if="localEnterprise.billingCustomer.id">
      <div class="md-layout md-gutter mb-1" v-if="!updatingOverage">
        <div class="md-layout-item md-small-size-100 mb-1">
          <p class="md-subheading">Price per verified identity</p>

          <span
            class="md-subheading mb-1"
            v-if="localEnterprise.owner.stripeIdentityOveragePrice"
          >
            {{ localEnterprise.owner.stripeIdentityOveragePrice | toCurrency }}
          </span>

          <span
            class="md-subheading"
            v-if="!localEnterprise.owner.stripeIdentityOveragePrice"
          >
            Not set.
          </span>
        </div>
      </div>

      <form
        class="md-layout md-gutter"
        v-if="updatingOverage"
        @submit.prevent="saveEnterpriseOveragePrice"
      >
        <div class="md-layout-item md-small-size-100">
          <md-field name="newPrice">
            <label for="newPrice">Price (format: 0.00)</label>
            <md-input v-model="overage.newPrice" name="newPrice" />
          </md-field>
        </div>
      </form>

      <div class="md-layout">
        <div class="md-layout-item md-size-100">
          <md-button
            class="md-raised"
            v-if="!updatingOverage"
            @click="updatingOverage = true"
          >
            Update overage price
          </md-button>

          <md-button
            class="md-raised md-primary"
            v-if="updatingOverage"
            @click="saveEnterpriseOveragePrice"
          >
            Save overage price
          </md-button>

          <md-button
            class="md-raised"
            v-if="updatingOverage"
            @click="updatingOverage = false"
          >
            Cancel
          </md-button>
        </div>
      </div>
    </div>

    <snackbar-message-handler :message="snackbarMessage" />
  </div>
</template>

<script type="ts">
import EnterpriseService from '@/services/enterprise/EnterpriseService';
import SnackbarMessageHandler from '@/components/snackbarMessage.vue';

export default {
  name: 'enterprise-identity-overage',

  components: {
    SnackbarMessageHandler,
  },

  props: ['enterprise'],

  data: () => ({
    updatingOverage: false,
    creatingPrice: false,
    enterpriseService: new EnterpriseService(),
    overage: {
      newPrice: '',
      prices: [],
    },
    snackbarMessage: '',
  }),

  computed: {
    localEnterprise: {
      get() {
        return this.enterprise;
      },
      set(value) {
        this.$emit('enterpriseChange', value);
      },
    },
  },

  methods: {
    saveEnterpriseOveragePrice() {
      let amount = Math.trunc(parseFloat(this.overage.newPrice) * 100);

      if (amount === 0) {
        amount = null;
      }

      this.enterpriseService.updateEnterprise(
        this.enterprise.id,
        {
          owner: {
            stripeIdentityOveragePrice: amount,
          },
        },
      ).then(() => {
        this.snackbarMessage = 'Identity overage price updated.';
        this.updatingOverage = false;
        this.localEnterprise.owner.stripeIdentityOveragePrice = amount;
      });
    },
  },

  mounted() {
    this.overage.newPrice = this.enterprise.owner.stripeIdentityOveragePrice / 100;
  },
};
</script>
